import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { LC_AUTH_TOKEN } from "@/shared/const/storageKeys";
import { snakeToCamelCase } from "@/shared/utils/utils";

const baseQueryWithTransform = fetchBaseQuery({
  baseUrl: __API__,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem(LC_AUTH_TOKEN) || "";

    if (token) {
      headers.set("Authorization", `Token ${token}`);
    }
    return headers;
  },
});

const baseQueryWithCamelCase = async (args, api, extraOptions) => {
  const result = await baseQueryWithTransform(args, api, extraOptions);

  if (result.data) {
    return {
      ...result,
      data: snakeToCamelCase(result.data),
    };
  }

  return result;
};

export const rtkApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithCamelCase,
  endpoints: () => ({}),
});
